<template>
  <div class="the-sider">
    <el-menu class="menu" background-color="#1f2e54" v-if="sideMenus.length > 0" text-color="#687bad" active-text-color="#d9e2ff"
      unique-opened :default-active="leafMenu.path" @select="select" @open="open" :collapse="!isExpand" :collapse-transition="false">
      <el-submenu v-for="subMenu in sideMenus" :key="subMenu.path" :index="subMenu.path">
        <template v-slot:title>
          <i class="iconfontI" :class="subMenu.moduleIcon"></i>
          <span class="title">{{ subMenu.name }}</span>
        </template>
        <el-menu-item v-for="leafMenu in subMenu.children" :key="leafMenu.path" :index="leafMenu.path">
          <i :class="leafMenu.moduleIcon"></i>
          {{ leafMenu.name }}
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'TheSider',
  props: ['isExpand'],
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['sideMenus']),
    ...mapState(['leafMenu', 'rootMenu'])
  }, 
  methods: {
    ...mapMutations(['setLeafMenu', 'addTab']),
    open (idx) {
      let leafMenu = this.sideMenus.find(item => item.path === idx).children[0]
      if (this.$route.path !== leafMenu.path) {
        this.setLeafMenu({
          name: leafMenu.name,
          path: leafMenu.path,
          code: leafMenu.moduleCode
        })
        this.addTab({
          leafMenu: {
            name: leafMenu.name,
            path: leafMenu.path,
            code: leafMenu.moduleCode
          },
          rootMenu: this.rootMenu
        })
        this.$router.push(leafMenu.path)
      }
    },
    select (idx, indexPath) {
      if (this.$route.path !== idx) {
        let leafMenu = this.sideMenus.find(item => item.path === indexPath[0]).children.find(it => it.path === idx)
        this.setLeafMenu({
          name: leafMenu.name,
          path: leafMenu.path,
          code: leafMenu.moduleCode
        })
        this.addTab({
          leafMenu: {
            name: leafMenu.name,
            path: leafMenu.path,
            code: leafMenu.moduleCode
          },
          rootMenu: this.rootMenu
        })
        this.$router.push(idx)
      }
    }
  }
}
</script>

<style lang="less">
.the-sider {
  display: block;
  width: 240px;
  position: absolute;
  top: 60px;
  bottom: 0;
  left: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  background-color: #1f2e54;
  .el-submenu {
    width: 240px;
  }
  .menu:not(.el-menu--collapse) {
    width: 240px;
    .el-menu-item {
      width: 240px;
    }
  }
  .menu.el-menu--collapse {
    .el-submenu, .el-menu-item {
      width: 64px;
    }
  }
  .el-submenu {
    width: 240px;
    .el-submenu__title {
      // color: #5aaeff!important;
      .iconfontI{margin-right:5px;}
    }
    &.is-active {
      .el-submenu__title {
        color: #5aaeff!important;
        // background-color: #368bff!important;
        .iconfontI{color: #fff !important;}
      }
    }
  }
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
